import {IconButton, InputAdornment, TextField} from "@material-ui/core";
import KeyboardRounded from "@material-ui/icons/KeyboardRounded";
import CloseRounded from "@material-ui/icons/CloseRounded";
import React, {useEffect, useState} from "react";
import {SimpleDialog} from "../../helpers/dialogs/simple.dialog";

export function ManualScan({onScanCode, scanActive}) {
    const [code, setCode] = useState("");
    const [codeDialogOpen, setCodeDialogOpen] = useState(false);

    useEffect(() => {
        scanActive.current = !codeDialogOpen;
    }, [codeDialogOpen]);

    return (
        <>
            <IconButton color="inherit" onClick={() => setCodeDialogOpen(true)}>
                <KeyboardRounded fontSize={"small"}/>
            </IconButton>
            <SimpleDialog
                open={codeDialogOpen}
                title={"Ingreso Manual"}
                body={
                    <>
                        <TextField
                            label="Ingreso"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            InputProps={{
                                endAdornment:
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => setCode("")}>
                                            <CloseRounded fontSize={"medium"}/>
                                        </IconButton>
                                    </InputAdornment>
                            }}
                        />
                    </>
                }
                onConfirm={() => {
                    setCodeDialogOpen(false);
                    onScanCode(code);
                }}
                onCancel={() => setCodeDialogOpen(false)}
            />
        </>
    )
}
